import { render, staticRenderFns } from "./NoticiasMercadoVideoDetails.vue?vue&type=template&id=b87007c4&"
import script from "./NoticiasMercadoVideoDetails.vue?vue&type=script&lang=js&"
export * from "./NoticiasMercadoVideoDetails.vue?vue&type=script&lang=js&"
import style0 from "./NoticiasMercadoVideoDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports